var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2451 5.99993C16.036 7.13376 16.4998 8.51268 16.4998 9.99993C16.4998 11.4872 16.036 12.8661 15.2451 13.9999M9.13432 2.36561L5.96863 5.5313C5.79568 5.70425 5.7092 5.79073 5.60828 5.85257C5.51881 5.9074 5.42127 5.9478 5.31923 5.9723C5.20414 5.99993 5.08185 5.99993 4.83726 5.99993H3.1C2.53995 5.99993 2.25992 5.99993 2.04601 6.10892C1.85785 6.20479 1.70487 6.35777 1.60899 6.54594C1.5 6.75985 1.5 7.03987 1.5 7.59993V12.3999C1.5 12.96 1.5 13.24 1.60899 13.4539C1.70487 13.6421 1.85785 13.7951 2.04601 13.8909C2.25992 13.9999 2.53995 13.9999 3.1 13.9999H4.83726C5.08185 13.9999 5.20414 13.9999 5.31923 14.0276C5.42127 14.0521 5.51881 14.0925 5.60828 14.1473C5.7092 14.2091 5.79568 14.2956 5.96863 14.4686L9.13431 17.6342C9.56269 18.0626 9.77688 18.2768 9.96077 18.2913C10.1203 18.3038 10.2763 18.2392 10.3802 18.1175C10.5 17.9773 10.5 17.6744 10.5 17.0686V2.9313C10.5 2.32548 10.5 2.02257 10.3802 1.88231C10.2763 1.76061 10.1203 1.69602 9.96077 1.70858C9.77688 1.72305 9.56269 1.93724 9.13432 2.36561Z",
    stroke: "#596173",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIcon);
export default __webpack_public_path__ + "static/media/voiceIcon.6eb10c2630dea03b6bda5257b4c70c73.svg";
export { ForwardRef as ReactComponent };